<div class="footer-app">
    <footer class="content-app">
        <div class="row">
            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12">
                <a routerLink="/" title="RedLaboralRD" class="d-block mt-3 mb-3 mx-auto" style="max-width: 400px;">
                    <img src="assets/Images/logo-white.png" class="img-fluid" alt="logo" />
                </a>
            </div>
            <div class="col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="mt-3 mb-0 text-center">
                            <span class="text-white">Siguenos en: </span>
                            <a href="#" class="d-block-inline mx-2 text-white" title="Facebook">
                                <i class="fa-brands fa-facebook fa-15x"></i>
                            </a>
                            <a href="#" class="d-block-inline mx-2 text-white" title="Instagram">
                                <i class="fa-brands fa-instagram fa-15x"></i>
                            </a>
                            <a href="#" class="d-block-inline mx-2 text-white" title="X">
                                <i class="fa-brands fa-square-x-twitter fa-15x"></i>
                            </a>
                            <a href="#" class="d-block-inline mx-2 text-white" title="Youtube">
                                <i class="fa-brands fa-youtube fa-15x"></i>
                            </a>
                            <a href="mailto:correo@correo.com" class="d-block-inline mx-2 text-white" title="Correo">
                                <i class="fa-regular fa-envelope fa-15x"></i>
                            </a>
                        </div>
                        <p class="text-white mt-2 mb-2 text-center" style="font-size: .85em;">
                            © 2024 Derechos reservados, RedLaborad RD.<br />
                            El uso de este site implica la aceptación de nuestra
                            política de privacidad y términos y condiciones de uso.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</div>